import React, { useContext, useState, useCallback, useEffect, useMemo } from 'react';
import { Lang } from '../../common/decorators/Language';
import UserContext, { StoreContext } from '../../common/utils/getContext';
import LogReg from '../../layouts/logreg/LogReg/LogReg';
import css from './AuthModal.module.scss';
import classnames from 'classnames';
import { Portal, zendoStorage } from '../../hybrid/wrappers';
import Register from '../../views/authentication/register/Register';
import Login from '../../views/authentication/login/Login';
import T from '../../common/components/T';
import PasswordRecover from '../../views/authentication/password_recover/PasswordRecover';
import PasswordReset from '../../views/authentication/password-reset/PasswordReset';
import { API_SERVER_URL, getCartData } from '../../common/utils/utils';
import { dataSender, navigateV2 } from '../../common/utils/router';

const RegistrationWindow = ({ customClasses }) => {
    const [expandedAuthBlock, setExpandedAuthBlock] = useState(true);
    const { showRegWindow, setState, userToken, storageLoaded, lang, localization, profile } = useContext(UserContext);
    const { setCartData, setReloadCart } = useContext(StoreContext) || {};
    const [type, setType] = useState(showRegWindow?.['type'] === 'string' ? showRegWindow?.['type'] : 'login');

    useEffect(() => {
        if (showRegWindow?.['type']) {
            setType(showRegWindow?.['type']);
        }
    }, [showRegWindow]);

    const afterConfirm = useCallback(
        async (token) => {
            if (storageLoaded) {
                // const cardId = zendoStorage.get('cart_id');
                const cardId = null;
                zendoStorage.remove('cart_id');
                const cartDataRes = await getCartData(cardId, token, lang, false, localization?.currency);
                if (!cartDataRes?.data) {
                    dataSender(
                        `${API_SERVER_URL}/api/v1/shop/carts/${cardId || cartDataRes?.data?.id}`,
                        'DELETE',
                        false,
                        () => {
                            if (typeof setReloadCart === 'function') setReloadCart((s) => !s);
                        },
                        () => {},
                        userToken,
                        lang,
                        profile?.country?.currency || localization?.currency?.code
                    );
                }
            }

            if (showRegWindow?.handler) {
                await showRegWindow?.handler(token);
            } else if (showRegWindow?.redirect) {
                navigateV2(showRegWindow?.redirect);
            }
            setState('showRegWindow', false);
        },
        [showRegWindow, storageLoaded, lang, localization?.currency, setCartData, profile]
    );

    const defaultStepData = useMemo(
        () =>
            type === 'password-recover-test'
                ? {
                      component: PasswordRecover,
                      props: { setType, message: { error: false } }
                  }
                : false,
        [type]
    );

    const [stepData, setStepData] = useState(defaultStepData);

    useEffect(() => {
        setStepData(defaultStepData);
    }, [defaultStepData, type]);

    const closeHandler = () => {
        setState('showRegWindow', false);
    };

    useEffect(() => {
        if (userToken && type === 'login') setState('showRegWindow', false);
    }, [userToken, type]);

    if (!showRegWindow) return null;
    return (
        <Portal closeHandler={closeHandler}>
            <LogReg
                expandedAuthBlock={expandedAuthBlock}
                changeExpandAuthBlock={setExpandedAuthBlock}
                compCss={{
                    loginWrapper: classnames(css.loginWrapper, css.loginWrapperMod)
                }}
                closeHandler={closeHandler}
            >
                {stepData ? (
                    <stepData.component {...stepData.props} />
                ) : (
                    <>
                        <div className={css.topInfo}>
                            <div className={css.iconVideo}>
                                <video
                                    className={classnames(css.videoMask, 'hideControls')}
                                    src='../../src/video/office/bg_video.mp4'
                                    autoPlay
                                    loop
                                    muted
                                    disablePictureInPicture
                                    playsInline
                                    controls={false}
                                ></video>
                            </div>
                            <p className={css.modalTitle}>
                                {type === 'login' ? (
                                    <T textName='welcome-back' defaultStr='С возвращением' />
                                ) : type === 'register' ? (
                                    <T textName='welcome' defaultStr='Добро пожаловать' />
                                ) : type === 'password-reset' ? (
                                    <T textName='password-reset' defaultStr='Восстановление пароля' />
                                ) : null}
                            </p>

                            {/* <p className={css.modalSubtitle}>
                                {type === 'login' ? (
                                    <T
                                        textName='enter-your-details-to-login-an-account'
                                        defaultStr='Введите свои данные для входа в аккаунт'
                                    />
                                ) : type === 'register' ? (
                                    <T
                                        textName='enter-your-details-to-register-an-account'
                                        defaultStr='Введите свои данные для регистрации аккаунта'
                                    />
                                ) : null}
                            </p> */}
                            {type === 'login' ? (
                                <div>
                                    <p className={css.modalSubtitle}>
                                        <T
                                            textName='enter-your-details-to-login-an-account'
                                            defaultStr='Введите свои данные для входа в аккаунт'
                                        />
                                        .
                                    </p>
                                    {/* <p className={css.modalSubtitle}>
                                        <T
                                            textName='enter-your-details-to-login-an-account-2'
                                            defaultStr='У вас нет учетной записи'
                                        />
                                        ?
                                        <Link href='/auth/register' className={css.modalSubtitleRegisterButton}>
                                            <T textName='register' defaultStr='Зарегистрироваться' />
                                        </Link>
                                    </p> */}
                                </div>
                            ) : type === 'password-reset' ? (
                                <p className={css.modalSubtitle}>
                                    <T
                                        textName='your-password-will-be-changed'
                                        defaultStr='Ваш пароль будет изменен. Введите новый пароль'
                                    />
                                    .
                                </p>
                            ) : null}
                        </div>
                        {type === 'password-recover' ? (
                            <PasswordRecover changePage={setType} />
                        ) : (
                            <>
                                {/* <FormRadioSwitcher
                                    options={storeTabs.map((tab) => tab.tabName)}
                                    value={switcherValue}
                                    setFormData={(attr, value) => setType(storeTabs[value].alias)}
                                    compStyle={{ wrapper: css.switcherWrapper, content: css.switcher }}
                                /> */}
                                {type === 'login' ? (
                                    <Login
                                        customClasses={customClasses}
                                        setStepData={setStepData}
                                        afterConfirm={afterConfirm}
                                        changePage={setType}
                                        expandedAuthBlock
                                    />
                                ) : type === 'register' ? (
                                    <Register afterConfirm={afterConfirm} setStepData={setStepData} />
                                ) : type === 'password-reset' ? (
                                    <PasswordReset />
                                ) : null}
                            </>
                        )}
                    </>
                    // <TabsMain
                    //     tabs={storeTabs}
                    //     tabsComponents={{
                    //         login: (
                    //             <Login
                    //                 customClasses={customClasses}
                    //                 setStepData={setStepData}
                    //                 afterConfirm={afterConfirm}
                    //                 changePage={setType}
                    //                 expandedAuthBlock
                    //             />
                    //         ),
                    //         register: <Register afterConfirm={afterConfirm} setStepData={setStepData} />
                    //     }}
                    //     compCss={css}
                    //     activeTab={type}
                    //     changePage={setType}
                    // />
                )}
            </LogReg>
        </Portal>
    );
};
export default Lang(RegistrationWindow, '/authentication');
